import { number } from '../QrCampaigns/liveModel';

export { csv, download, number } from '../QrCampaigns/liveModel';
export type Row = Record<string, unknown>;
export const text = (v: unknown): string =>
  v === null || v === undefined ? 'Unknown' : String(typeof v === 'object' && 'value' in v ? v.value : v);
export const sum = (rows: Array<Row>, key: string): number | null => {
  const values = rows.map((r) => number(r[key])).filter((v): v is number => v !== null);
  return values.length ? values.reduce((a, b) => a + b, 0) : null;
};
export const ratio = (a: number | null, b: number | null): number | null =>
  a === null || b === null || b === 0 ? null : a / b;
export const format = (v: unknown, percent = false) => {
  const n = number(v);
  return n === null
    ? 'Unknown'
    : new Intl.NumberFormat('en-AU', {
        maximumFractionDigits: 2,
        ...(percent ? { style: 'percent' as const } : {}),
      }).format(n);
};
